import { render, staticRenderFns } from "./HqSelfPayPaymentMethod.vue?vue&type=template&id=85caede8&scoped=true&lang=pug&"
import script from "./HqSelfPayPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./HqSelfPayPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./HqSelfPayPaymentMethod.vue?vue&type=style&index=0&id=85caede8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85caede8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VMenu,VRow,VSpacer})
